module.exports = __webpack_public_path__ + "static/media/ijasah.823bce1f.jpg";